import {useTranslation} from "react-i18next";
import PropTypes from "prop-types";
import React from "react";
import Select from "./Select";

export default function BoolSelect(props) {
  const { t } = useTranslation();

  return (
    <Select {...props} >
      <Option value={true}>{props.yes || t("yes")}</Option>
      <Option value={false}>{props.no || t("no")}</Option>
    </Select>
  )
}

BoolSelect.propTypes = {
  yes: PropTypes.node,
  no: PropTypes.node
}
